import { useState, useCallback } from "react";
import flotteService from "../../../../services/flotteService";
import useStore from "../../../../context/useStore";

const useSecteurEnMasse = (data, { onComplete } = {}) => {
  const [state] = useStore();
  const [secteur, setSecteur] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rapport, setRapport] = useState(null);

  const secteurs = state?.constant?.items?.CONTRAT?.SECTEURS || {};
  const secteurOptions = [
    ...(secteurs.reunion || []).map((item) => ({
      id: item.id,
      name: `Réunion - ${item.name}`,
    })),
    ...(secteurs.mayotte || []).map((item) => ({
      id: item.id,
      name: `Mayotte - ${item.name}`,
    })),
  ];

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!secteur) return;

      setIsSubmitting(true);
      setRapport(null);

      try {
        const result = await flotteService.modifierSecteurEnMasse({
          vehiculeIds: data.map((item) => item.vehicleId),
          secteur,
        });
        setRapport(result);

        if (onComplete) {
          await onComplete();
        }
      } catch (error) {
        console.error(
          "Erreur lors de la modification en masse du secteur:",
          error,
        );
      } finally {
        setIsSubmitting(false);
      }
    },
    [secteur, data, onComplete],
  );

  const getResultForVehicle = useCallback(
    (vehicleId) => {
      if (!rapport) return null;
      if (rapport.succes.includes(vehicleId)) return { status: "success" };

      const echec = rapport.echecs.find((item) => item.id === vehicleId);
      if (echec) return { status: "error", raison: echec.raison };

      return null;
    },
    [rapport],
  );

  const getStatusIcon = useCallback((result) => {
    if (!result) return <i className="fas fa-clock text-muted"></i>;
    if (result.status === "success") {
      return <i className="fas fa-check-circle text-success"></i>;
    }
    return <i className="fas fa-times-circle text-danger"></i>;
  }, []);

  return {
    secteur,
    setSecteur,
    secteurOptions,
    isSubmitting,
    rapport,
    handleSubmit,
    getResultForVehicle,
    getStatusIcon,
  };
};

export default useSecteurEnMasse;
